export enum WithdrawalProvider {
  Tremendous = 'tremendous',
  PayPal = 'paypal',
}
